export default {_name:'text.status',module:'Field',view:'Element/Text/Status',options:{xs:12},mobileOptions:{ms:12}}